import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.slice.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "card card-custom card-stretch gutter-b"
  }, [_vm._m(0), _c('div', {
    staticClass: "card card-custom gutter-b",
    staticStyle: {
      "box-shadow": "none"
    }
  }, [_c('div', {
    staticClass: "card-header card-header-tabs-line"
  }, [_c('ul', {
    ref: "builder-tab",
    staticClass: "nav nav-dark nav-bold nav-tabs nav-tabs-line",
    attrs: {
      "role": "tablist"
    }
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link active",
    attrs: {
      "data-tab": "0",
      "data-toggle": "tab",
      "href": "#",
      "role": "tab"
    },
    on: {
      "click": _vm.setActiveTab
    }
  }, [_vm._v(" Identificação ")])]), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "data-tab": "1",
      "data-toggle": "tab1",
      "href": "#",
      "role": "tab1"
    },
    on: {
      "click": _vm.setActiveTab
    }
  }, [_vm._v(" Tributação de PIS e CONFINS ")])]), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "data-tab": "2",
      "data-toggle": "tab2",
      "href": "#",
      "role": "tab1"
    },
    on: {
      "click": _vm.setActiveTab
    }
  }, [_vm._v(" Retenções ")])]), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "data-tab": "3",
      "data-toggle": "tab2",
      "href": "#",
      "role": "tab1"
    },
    on: {
      "click": _vm.setActiveTab
    }
  }, [_vm._v(" Regras de ISS por cidade ")])])])]), _c('div', {
    staticClass: "card-body"
  }, [_c('b-tabs', {
    staticClass: "hide-tabs",
    model: {
      value: _vm.tabIndex,
      callback: function callback($$v) {
        _vm.tabIndex = $$v;
      },
      expression: "tabIndex"
    }
  }, [_c('b-tab', {
    attrs: {
      "active": ""
    }
  }, [_c('b-row', [_c('b-col', [_c('b-form-group', {
    attrs: {
      "id": "descricao",
      "label-for": "descricao",
      "label": "Descrição"
    }
  }, [_c('b-form-input', {
    attrs: {
      "autofocus": ""
    },
    model: {
      value: _vm.form.descricao,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "descricao", $$v);
      },
      expression: "form.descricao"
    }
  })], 1)], 1)], 1), _c('b-row', [_c('b-col', [_c('b-form-group', {
    attrs: {
      "id": "tributacao",
      "label-for": "tributacao",
      "label": "Tributação"
    }
  }, [_c('b-form-select', {
    key: _vm.render,
    attrs: {
      "placeholder": "Selecione o tipo de tributação"
    },
    model: {
      value: _vm.tributacao,
      callback: function callback($$v) {
        _vm.tributacao = $$v;
      },
      expression: "tributacao"
    }
  }, _vm._l(_vm.tributacaoTipos, function (tipo) {
    return _c('b-form-select-option', {
      key: tipo.descricao + 'tributacao',
      attrs: {
        "value": tipo.codigo
      }
    }, [_vm._v(" " + _vm._s(tipo.descricao) + " ")]);
  }), 1)], 1)], 1), _c('b-col', [_c('b-form-group', {
    attrs: {
      "id": "exigibilidade",
      "label-for": "exigibilidade",
      "label": "Exigibilidade"
    }
  }, [_c('b-form-select', {
    key: _vm.render,
    attrs: {
      "placeholder": "Selecione a exigibilidade"
    },
    model: {
      value: _vm.exigibilidade,
      callback: function callback($$v) {
        _vm.exigibilidade = $$v;
      },
      expression: "exigibilidade"
    }
  }, _vm._l(_vm.exigibilidadeTipos, function (tipo) {
    return _c('b-form-select-option', {
      key: tipo.descricao + 'exigibilidade',
      attrs: {
        "value": tipo.codigo
      }
    }, [_vm._v(" " + _vm._s(tipo.descricao) + " ")]);
  }), 1)], 1)], 1), _c('b-col', [_c('b-form-group', {
    attrs: {
      "id": "tipo_imunidade",
      "label-for": "tipo_imunidade",
      "label": "Tipo Imunidade"
    }
  }, [_c('b-form-select', {
    key: _vm.render,
    attrs: {
      "placeholder": "Selecione o tipo da imunidade"
    },
    model: {
      value: _vm.form.tipo_imunidade,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "tipo_imunidade", $$v);
      },
      expression: "form.tipo_imunidade"
    }
  }, _vm._l(_vm.tipoImunidade, function (tipo) {
    return _c('b-form-select-option', {
      key: tipo.descricao + 'tipo_imunidade',
      attrs: {
        "value": tipo.codigo
      }
    }, [_vm._v(" " + _vm._s(tipo.descricao) + " ")]);
  }), 1)], 1)], 1), _c('b-col', [_c('b-form-group', {
    attrs: {
      "id": "versao_rtc",
      "label-for": "versao_rtc",
      "label": "Versão RTC"
    }
  }, [_c('span', {
    staticClass: "switch switch-icon"
  }, [_c('label', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover.right",
      value: 'Não/Sim',
      expression: "'Não/Sim'",
      modifiers: {
        "hover": true,
        "right": true
      }
    }]
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.versao_rtc,
      expression: "form.versao_rtc"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.form.versao_rtc) ? _vm._i(_vm.form.versao_rtc, null) > -1 : _vm.form.versao_rtc
    },
    on: {
      "change": function change($event) {
        var $$a = _vm.form.versao_rtc,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.form, "versao_rtc", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.form, "versao_rtc", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.form, "versao_rtc", $$c);
        }
      }
    }
  }), _c('span')])])])], 1)], 1)], 1), _c('b-tab', [_c('b-row', [_c('b-col', [_c('b-form-group', {
    attrs: {
      "id": "cst",
      "label-for": "cst",
      "label": "CST de PIS/COFFINS"
    }
  }, [_c('VueSelect', {
    attrs: {
      "label": "codigo",
      "options": _vm.cstcofinsOptions,
      "value": _vm.cstSelected,
      "placeholder": "Digite o código para pesquisar"
    },
    on: {
      "input": _vm.setCst
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "d-center"
        }, [_vm._v(" " + _vm._s(option.codigo + " - " + option.descricao) + " ")])];
      }
    }, {
      key: "selected-option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "selected d-center"
        }, [_vm._v(" " + _vm._s(option.codigo + " - " + option.descricao) + " ")])];
      }
    }])
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v(" Informe o código do CST Cofins ")])], 2)], 1)], 1), _c('b-col', [_c('b-form-group', {
    attrs: {
      "id": "base_pis_cofins",
      "label-for": "base_pis_cofins",
      "label": "% BC PIS/COFINS"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    attrs: {
      "id": "base_pis_cofins",
      "name": "base_pis_cofins"
    },
    model: {
      value: _vm.form.base_pis_cofins,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "base_pis_cofins", $$v);
      },
      expression: "form.base_pis_cofins"
    }
  }, 'money', _vm.configMask, false))], 1)], 1), _c('b-col', [_c('b-form-group', {
    attrs: {
      "id": "aliquota_pis",
      "label-for": "aliquota_pis",
      "label": "% Aliquota PIS"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    attrs: {
      "autofocus": ""
    },
    model: {
      value: _vm.form.aliquota_pis,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "aliquota_pis", $$v);
      },
      expression: "form.aliquota_pis"
    }
  }, 'money', _vm.configMask, false))], 1)], 1), _c('b-col', [_c('b-form-group', {
    attrs: {
      "id": "aliquota_cofins",
      "label-for": "aliquota_cofins",
      "label": "% Aliquota COFINS"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    attrs: {
      "autofocus": ""
    },
    model: {
      value: _vm.form.aliquota_cofins,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "aliquota_cofins", $$v);
      },
      expression: "form.aliquota_cofins"
    }
  }, 'money', _vm.configMask, false))], 1)], 1), _c('b-col', [_c('b-form-group', {
    attrs: {
      "id": "aliquota_ibpt",
      "label-for": "aliquota_ibpt",
      "label": "% Aliquota IBPT"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    model: {
      value: _vm.form.aliquota_ibpt,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "aliquota_ibpt", $$v);
      },
      expression: "form.aliquota_ibpt"
    }
  }, 'money', _vm.configMask, false))], 1)], 1), _c('b-col', [_c('b-form-group', {
    attrs: {
      "id": "grupo_aliquota_simples",
      "label-for": "aliquota_simples"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_vm._v(" % Alíquota do Simples Nacional "), _c('span', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover.focus",
            modifiers: {
              "hover": true,
              "focus": true
            }
          }],
          staticClass: "ml-1 text-muted",
          staticStyle: {
            "cursor": "help"
          },
          attrs: {
            "tabindex": "0",
            "title": "Valor percentual aproximado do total dos tributos da alíquota do Simples Nacional",
            "aria-label": "Valor percentual aproximado do total dos tributos da alíquota do Simples Nacional"
          }
        }, [_c('i', {
          staticClass: "fas fa-info-circle",
          attrs: {
            "aria-hidden": "true"
          }
        })])];
      },
      proxy: true
    }])
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    attrs: {
      "id": "aliquota_simples",
      "name": "aliquota_simples"
    },
    model: {
      value: _vm.form.aliquota_simples,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "aliquota_simples", $$v);
      },
      expression: "form.aliquota_simples"
    }
  }, 'money', _vm.configMask, false))], 1)], 1)], 1)], 1), _c('b-tab', [_c('b-row', [_c('b-col', [_c('b-form-group', {
    attrs: {
      "id": "retencao_pis",
      "label-for": "retencao_pis",
      "label": "% PIS"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    model: {
      value: _vm.form.retencao_pis,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "retencao_pis", $$v);
      },
      expression: "form.retencao_pis"
    }
  }, 'money', _vm.configMask, false))], 1)], 1), _c('b-col', [_c('b-form-group', {
    attrs: {
      "id": "retencao_cofins",
      "label-for": "retencao_cofins",
      "label": "% COFINS"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    model: {
      value: _vm.form.retencao_cofins,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "retencao_cofins", $$v);
      },
      expression: "form.retencao_cofins"
    }
  }, 'money', _vm.configMask, false))], 1)], 1), _c('b-col', [_c('b-form-group', {
    attrs: {
      "id": "retencao_csll",
      "label-for": "retencao_csll",
      "label": "% CSLL"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    model: {
      value: _vm.form.retencao_csll,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "retencao_csll", $$v);
      },
      expression: "form.retencao_csll"
    }
  }, 'money', _vm.configMask, false))], 1)], 1)], 1), _c('b-row', [_c('b-col', [_c('b-form-group', {
    attrs: {
      "id": "retencao_inss",
      "label-for": "retencao_inss",
      "label": "% INSS"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    model: {
      value: _vm.form.retencao_inss,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "retencao_inss", $$v);
      },
      expression: "form.retencao_inss"
    }
  }, 'money', _vm.configMask, false))], 1)], 1), _c('b-col', [_c('b-form-group', {
    attrs: {
      "id": "retencao_irrf",
      "label-for": "retencao_irrf",
      "label": "% IRFF"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    model: {
      value: _vm.form.retencao_irrf,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "retencao_irrf", $$v);
      },
      expression: "form.retencao_irrf"
    }
  }, 'money', _vm.configMask, false))], 1)], 1), _c('b-col', [_c('b-form-group', {
    attrs: {
      "id": "retencao_cpp",
      "label-for": "retencao_cpp",
      "label": "% CPP"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    model: {
      value: _vm.form.retencao_cpp,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "retencao_cpp", $$v);
      },
      expression: "form.retencao_cpp"
    }
  }, 'money', _vm.configMask, false))], 1)], 1)], 1)], 1), _c('b-tab', [_c('button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.modal-iss-cidade",
      modifiers: {
        "modal-iss-cidade": true
      }
    }],
    staticClass: "btn btn-sm btn-primary btn-hover-secondary btn-icon mr-2 mb-2"
  }, [_c('PlusIcon', {
    attrs: {
      "size": 26
    }
  })], 1), _c('TableApp', {
    ref: "codade",
    attrs: {
      "item": "registro",
      "subTitulo": "",
      "data": _vm.regras,
      "fields": _vm.fields,
      "classFilterColumn": "cidade"
    },
    scopedSlots: _vm._u([{
      key: "customRow",
      fn: function fn(props) {
        var _props$rowData, _props$rowData2, _props$rowData3;
        return [props.field == 'cidade' ? _c('span', {
          staticClass: "pl-0 pt-8",
          attrs: {
            "slot": "nome"
          },
          slot: "nome"
        }, [_c('div', {
          staticClass: "d-flex align-items-center"
        }, [_c('div', {
          staticClass: "font-weight-bold text-muted"
        }, [_vm._v(" " + _vm._s((_props$rowData = props.rowData) === null || _props$rowData === void 0 ? void 0 : _props$rowData.cidade) + " ")])])]) : _vm._e(), props.field == 'aliquota_iss' ? _c('span', {
          staticClass: "pl-0 pt-8",
          attrs: {
            "slot": "iss"
          },
          slot: "iss"
        }, [_c('div', {
          staticClass: "d-flex align-items-center"
        }, [_c('div', {
          staticClass: "font-weight-bold text-muted"
        }, [_vm._v(" " + _vm._s(_vm.numberToReal((_props$rowData2 = props.rowData) === null || _props$rowData2 === void 0 ? void 0 : _props$rowData2.aliquota_iss, 4)) + " ")])])]) : _vm._e(), props.field == 'retencao_iss' ? _c('span', {
          staticClass: "pl-0 pt-8",
          attrs: {
            "slot": "preco"
          },
          slot: "preco"
        }, [_c('div', {
          staticClass: "d-flex align-items-center"
        }, [_c('div', {
          staticClass: "font-weight-bold text-muted"
        }, [_vm._v(" " + _vm._s(_vm.numberToReal((_props$rowData3 = props.rowData) === null || _props$rowData3 === void 0 ? void 0 : _props$rowData3.retencao_iss, 4)) + " ")])])]) : _vm._e(), props.field == 'actions' ? _c('span', {
          attrs: {
            "slot": "actions"
          },
          slot: "actions"
        }, [_c('div', {
          staticClass: "row-actions",
          staticStyle: {
            "text-align": "right !important"
          }
        }, [_c('span', {
          staticStyle: {
            "overflow": "visible",
            "position": "relative",
            "width": "130px"
          }
        }, [_c('div', {
          staticClass: "action-buttons"
        }, [_c('button', {
          staticClass: "btn btn-sm btn-danger btn-hover-danger btn-icon mr-2",
          on: {
            "click": function click($event) {
              return _vm.handleDeleteIss(props.rowData);
            }
          }
        }, [_c('TrashCanIcon', {
          attrs: {
            "size": 16
          }
        })], 1)])])])]) : _vm._e()];
      }
    }])
  })], 1)], 1)], 1), _c('div', {
    staticClass: "card-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('button', {
    ref: "submit_nova_tributacao",
    staticClass: "btn btn-primary font-weight-bold",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v(" Salvar ")]), _c('router-link', {
    staticClass: "btn btn-clean font-weight-bold",
    attrs: {
      "to": {
        name: 'tributacoesServicos'
      }
    }
  }, [_vm._v(" Cancelar ")])], 1)])])]), _c('b-modal', {
    attrs: {
      "id": "modal-iss-cidade",
      "size": "md",
      "centered": "",
      "title": "Adicionar município"
    },
    scopedSlots: _vm._u([{
      key: "modal-header",
      fn: function fn(_ref) {
        var close = _ref.close;
        return [_c('h5', [_vm._v("Adicionar município")]), _c('b-button', {
          attrs: {
            "size": "sm",
            "variant": "outline-danger"
          },
          on: {
            "click": function click() {
              close();
              _vm.openModal = false;
            }
          }
        }, [_vm._v(" X ")])];
      }
    }, {
      key: "modal-footer",
      fn: function fn(_ref2) {
        var ok = _ref2.ok,
          cancel = _ref2.cancel;
        return [_c('b-button', {
          on: {
            "click": function click() {
              cancel();
              _vm.openModal = false;
            }
          }
        }, [_vm._v(" Cancelar ")]), _c('b-button', {
          ref: "sendToWpp",
          attrs: {
            "variant": "primary"
          },
          on: {
            "click": _vm.addMunicipioISS
          }
        }, [_vm._v(" Adicionar ")])];
      }
    }])
  }, [_c('div', {
    staticClass: "mx-auto d-flex flex-column justify-content-center"
  }, [_c('b-row', [_c('b-col', [_c('b-form-group', {
    attrs: {
      "id": "municipio",
      "label-for": "municipio",
      "label": "Município"
    }
  }, [_c('VueSelect', {
    ref: "municipioSelect",
    attrs: {
      "label": "municipio",
      "options": _vm.municipiosOptions,
      "filterable": false,
      "placeholder": "Pesquise pelo nome do município"
    },
    on: {
      "search": _vm.onSearchMunicipio
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "d-center"
        }, [_vm._v(" " + _vm._s(option.cidade + " - " + option.uf) + " ")])];
      }
    }, {
      key: "selected-option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "selected d-center"
        }, [_vm._v(" " + _vm._s(option.cidade + "-" + option.uf) + " ")])];
      }
    }]),
    model: {
      value: _vm.municipioSelected,
      callback: function callback($$v) {
        _vm.municipioSelected = $$v;
      },
      expression: "municipioSelected"
    }
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v(" Insira o nome do município ")])], 2)], 1)], 1)], 1), _c('b-row', [_c('b-col', [_c('b-form-group', {
    attrs: {
      "id": "iss",
      "label-for": "iss",
      "label": "% Aliq. ISS"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    model: {
      value: _vm.municipioToAdd.aliquota_iss,
      callback: function callback($$v) {
        _vm.$set(_vm.municipioToAdd, "aliquota_iss", $$v);
      },
      expression: "municipioToAdd.aliquota_iss"
    }
  }, 'money', _vm.configTaxa, false))], 1)], 1), _c('b-col', [_c('b-form-group', {
    attrs: {
      "id": "retencaoIss",
      "label-for": "retencaoIss",
      "label": "% Retenção de ISS"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    model: {
      value: _vm.municipioToAdd.retencao_iss,
      callback: function callback($$v) {
        _vm.$set(_vm.municipioToAdd, "retencao_iss", $$v);
      },
      expression: "municipioToAdd.retencao_iss"
    }
  }, 'money', _vm.configTaxa, false))], 1)], 1)], 1)], 1)])], 1);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "card-header border-0 py-5"
  }, [_c('h3', {
    staticClass: "card-title align-items-start flex-column"
  }, [_c('span', {
    staticClass: "card-label font-weight-bolder text-dark"
  }, [_vm._v(" Nova Tributação ")])])]);
}];
export { render, staticRenderFns };